<script lang="ts" setup>
import { ScalarPopover } from '@scalar/components/popover'
import { ScalarIconCaretDown, ScalarIconInfo } from '@scalar/icons'

import { useLocalization } from '@/features/localization'

const { translate } = useLocalization()
</script>

<template>
  <ScalarPopover
    class="bg-b-2 dark:bg-b-2 max-h-[inherit] max-w-[inherit] rounded-lg p-0 text-base"
    placement="bottom-end"
    teleport>
    <template #default="{ open }">
      <slot
        name="button"
        :open>
        <button
          class="text-c-2 hover:text-c-1 hover:bg-b-2 flex items-center gap-1 rounded px-2 py-2.25 text-base leading-none"
          type="button">
          <slot name="label" />
          <ScalarIconCaretDown
            class="size-3"
            :class="{ 'rotate-180': open }" />
        </button>
      </slot>
    </template>
    <template #popover="props">
      <div class="custom-scroll bg-b-1 flex flex-col gap-7 rounded-lg p-7 pb-6">
        <slot v-bind="props" />
      </div>
      <div class="text-c-2 flex items-center justify-center gap-1 p-2 text-sm">
        <ScalarIconInfo class="size-3.5 shrink-0" />
        <div>
          <slot name="info">
            {{ translate('developerTools.localhostOnly') }}
          </slot>
        </div>
      </div>
    </template>
  </ScalarPopover>
</template>
